import * as React from 'react'
import { I18nService } from '../../services/utils/i18n.service'
import { httpGetRoute } from '../../services/utils/http.service'

interface Props { menu: Menu }
const i18nScoped = new I18nService(require('./menu-primary-in-header.component.yml'))
const LazyClockingButtonComponent = React.lazy(() => import('../employees/clockings/clocking-button.component'))

export default function MenuPrimaryInHeaderComponent ({ menu: { employee, customer,  backoffice, market } }: Props) {
  const isOperatorNotAccountant = window.currentUser.type === 'Operator' && window.currentUser.role !== 'accountant'
  const showClockingButton = employee.clockings || (isOperatorNotAccountant && backoffice.soloEdition && backoffice.clockingModule && (backoffice.clockingModes.includes('qrcode') || backoffice.clockingModes.includes('nfc')))
  const clockingButton = showClockingButton && <React.Suspense fallback={ null }><LazyClockingButtonComponent /></React.Suspense>

  // same active link logic as MenuSideComponent
  const subpath = window.location.href.split(httpGetRoute()).pop()
  const linkClassName = (...paths: string[]) => `headerMain-middle-link${ paths.some(path => subpath.startsWith(path)) ? ' is-active' : '' }`

  // every view rendering the menu_parameters partial belongs to "Paramètres & Services"
  const offeredServicesLinkClassName = `headerMain-middle-link${ window.menuParametersActive ? ' is-active' : '' }`

  return <>
    { window.currentUser.type === 'Employee' && clockingButton }

    { (customer.newCasting || employee.newCasting) && <a
      className="u-mrm u-mlm button button--S"
      href={ `/${window.market_type.toLocaleLowerCase()}s/${window.market_id}/castings/new` }
      children={ i18nScoped.t('new_casting') } /> }

    { isOperatorNotAccountant && window.market_type === 'Supplier' && <div className="headerMain-middle">
      <a className={ linkClassName('/castings') } href={ `/${httpGetRoute()}/castings` }>{ i18nScoped.t('castings') }</a>

      <a className={ linkClassName('/plannings', '/events') } href={ `/${httpGetRoute()}/plannings` }>
        { i18nScoped.t('events_operator') }
        { backoffice.anyIncomingEventToUpdate && <span className="menu-icon-count" style={{ position: 'static', height: '1.3em', marginLeft: '0.4em' }} /> }
      </a>

      <a className={ linkClassName('/customers') } href={ `/${httpGetRoute()}/customers` }>{ i18nScoped.t('customers') }</a>

      { backoffice.soloEdition
        ? <a className={ linkClassName('/invoices') } href={ `/${httpGetRoute()}/invoices` }>{ i18nScoped.t('invoicing') }</a>
        : <a className={ linkClassName('/employees') } href={ `/${httpGetRoute()}/employees` }>{ i18nScoped.t('employees') }</a> }

      { window.currentUser.role === 'admin_supplier' && <a
        className={ offeredServicesLinkClassName }
        href={ `/${httpGetRoute()}/offered_services` }
        children={ i18nScoped.t('offered_services_and_params') } /> }
    </div> }

    { window.currentUser.type === 'Operator' && window.market_type === 'Supplier'&& clockingButton }

    { isOperatorNotAccountant && window.market_type === 'Marketplace' && <div className="headerMain-middle">
      { market.marketplaceType === 'standart' && <>
        <a className={ linkClassName('/castings') } href={ `/${httpGetRoute()}/castings` }>{ i18nScoped.t('castings') }</a>
        <a className={ linkClassName('/customers') } href={ `/${httpGetRoute()}/customers` }>{ i18nScoped.t('customers') }</a>

        <a className={ linkClassName('/memberships') } href={ `/${httpGetRoute()}/memberships` }>
          { i18nScoped.t('suppliers') }
          { !!market.ogustineConnectNewSupplierCount && <span className="u-positionRelative menu-icon-count" style={{ top: '-0.3em', fontSize: '0.9rem' }}>{ market.ogustineConnectNewSupplierCount }</span> }
        </a>

        <a className={ linkClassName('/membership_prescribers') } href={ `/${httpGetRoute()}/membership_prescribers` }>{ i18nScoped.t('prescribers') }</a>

        { window.currentUser.role === 'admin_supplier' && <a
          className={ offeredServicesLinkClassName }
          href={ `/${httpGetRoute()}/offered_services` }
          children={ i18nScoped.t('offered_services_and_params') } /> }
      </> }

      { market.marketplaceType === 'independant' && <>
        <a className={ linkClassName('/invoices') } href={ `/${httpGetRoute()}/invoices` }>{ i18nScoped.t('invoicing') }</a>
        <a className={ linkClassName('/memberships') } href={ `/${httpGetRoute()}/memberships` }>{ i18nScoped.t('suppliers') }</a>
        <a className={ offeredServicesLinkClassName } href={ `/${httpGetRoute()}/offered_services` }>{ i18nScoped.t('offered_services_and_params') }</a>
      </> }
    </div> }
  </>
}
